export const manageusersData = [
  {
    id: 'U461893',
    name: 'Janet',
    class: 'III',
    section: 'A',
    dateOfJoined: '25 Mar 2024',
    status: 'Active',
    key: 1,
  },
];
